import { flag } from './model/flags'
import { setup } from './model/setup'
import { $features } from './model/store'

export const $$features = { setup, $all: $features, flag }

export { FeatureGuard } from './ui/FeatureGuard'
export { FeatureFlag } from './types'
